/**
 * Function to split an HTML string into an array of html string to render each element.,
 * Server-friendly (no window/document). Splits into top-level child elements of the outer wrapper.
 * @param html HTML string to be split into an array of strings.
 * @returns Array of child element HTML strings
 */
export const splitHtmlIntoArray = (html: string): string[] => {
  const trimmed = html?.trim() || "";
  if (!trimmed) return [];

  const match = trimmed.match(/^<([\w:-]+)[^>]*>([\s\S]*)<\/\1>\s*$/);
  const inner = match ? match[2] : trimmed;
  if (!inner) return [trimmed];

  const result: string[] = [];
  let i = 0,
    depth = 0,
    start = -1;
  while (i < inner.length) {
    const lessThanSymbolIndex = inner.indexOf("<", i);
    if (lessThanSymbolIndex === -1) break;
    const greaterThanSymbolIndex = inner.indexOf(">", lessThanSymbolIndex);
    if (greaterThanSymbolIndex === -1) break;
    const tag = inner
      .slice(lessThanSymbolIndex + 1, greaterThanSymbolIndex)
      .trim();
    const isClose = tag.startsWith("/");
    const isSelfClose = /\/$/.test(tag);

    if (!isClose && !isSelfClose && depth++ === 0) start = lessThanSymbolIndex;
    if (isClose && --depth === 0 && start !== -1) {
      result.push(inner.slice(start, greaterThanSymbolIndex + 1).trim());
      start = -1;
    }
    if (isSelfClose && depth === 0)
      result.push(
        inner.slice(lessThanSymbolIndex, greaterThanSymbolIndex + 1).trim()
      );
    i = greaterThanSymbolIndex + 1;
  }

  return result.length ? result : [trimmed];
};

/**
 * Function to get the total character length of an array of HTML strings.
 * Server-friendly (no window/document).
 * @param htmlArray Array of HTML strings.
 * @returns Total text length.
 */
export const getTotalTextLength = (htmlArray: string[]): number => {
  if (!htmlArray) return 0;

  return (htmlArray || []).reduce((sum, item) => {
    const textOnly = (item || "").replace(/<[^>]*>/g, "").trim();
    return sum + textOnly.length;
  }, 0);
};
